import { ADVISOR_SESSION_FRAGMENT } from '@src/gql/fragments/AdvisorSessionFragment'
import { gql } from '@src/lib/gql'

export const CONFIRM_ADVISOR_SESSION_SCHEDULE = gql`
  mutation ConfirmAdvisorSessionSchedule($input: ConfirmAdvisorSessionScheduleInput!) {
    confirmAdvisorSessionSchedule(input: $input) {
      advisorSession {
        ...AdvisorSessionFragment
      }
    }
  }
  ${ADVISOR_SESSION_FRAGMENT}
`
